<template>
  <Modal
    v-model="_value"
    width="500"
    title="查看潜在合拼车辆信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <div style="position:relative;">
      <div>
        <!--<p>业务状态：<label class="detailContent">{{comboVehicleInfo.businessState}}</label></p>-->
        <!--<p>主机号码：<label class="detailContent">{{detail_commNO}}</label></p>-->
        <p>车牌号码：<label class="detailContent">{{comboVehicleInfo.registrationNum}}</label></p>
<!--        <p>车牌颜色：<label class="detailContent">{{comboVehicleInfo.registrationColor}}</label></p>-->
<!--        <p>车辆类型：<label class="detailContent">{{comboVehicleInfo.vehicleTypeName}}</label></p>-->
<!--        <p>车辆品牌：<label class="detailContent">{{comboVehicleInfo.vehicleBrandName}}</label></p>-->
<!--        <p>车架号：<label class="detailContent">{{comboVehicleInfo.frameNum}}</label></p>-->
<!--        <p>发动机号：<label class="detailContent">{{comboVehicleInfo.engineNum}}</label></p>-->
<!--        <p>主机名称：<label class="detailContent">{{comboVehicleInfo.deviceName}}</label></p>-->
        <p>单位：<label class="detailContent">{{comboVehicleInfo.customCompanyName}}</label> 联系人：<label
          class="detailContent">{{comboVehicleInfo.customCompanyContact}}</label>
          联系电话：<label class="detailContent">{{comboVehicleInfo.customCompanyContactPhone}}</label></p>
        <p>所有人:<label class="detailContent">{{comboVehicleInfo.vehicleOwnerName}}</label> 联系电话：<label
          class="detailContent">{{comboVehicleInfo.vehicleOwnerPhone}}</label>
        </p>
<!--        <p>车主身份证号码：<label class="detailContent">{{comboVehicleInfo.vehicleOwnerIdcardNum}}</label></p>-->
        <p>联系地址:<label class="detailContent">{{comboVehicleInfo.vehicleOwnerAddress}}</label></p>
        <p>联系人1:<label class="detailContent">{{comboVehicleInfo.firstContactName}}</label>联系电话:<label
          class="detailContent">{{comboVehicleInfo.firstContactPhone}}</label>
        <p>联系地址:<label class="detailContent">{{comboVehicleInfo.firstContactAddress}}</label></p>
        <p>联系人2:<label class="detailContent">{{comboVehicleInfo.secondContactName}}</label>联系电话:<label
          class="detailContent">{{comboVehicleInfo.secondContactPhone}}</label>
        <p>联系地址:<label class="detailContent">{{comboVehicleInfo.secondContactAddress}}</label></p>
        <p>联系人3:<label class="detailContent">{{comboVehicleInfo.thirdContactName}}</label>联系电话:<label
          class="detailContent">{{comboVehicleInfo.thirdContactPhone}}</label>
        <p>联系地址:<label class="detailContent">{{comboVehicleInfo.thirdContactAddress}}</label></p>
        <!--<p>服务到期日期：<label class="detailContent">{{detail_serviceMatureDate | dataFormat}}</label></p>-->
        <p>年审日期：<label class="detailContent">{{formatDate(comboVehicleInfo.serviceMatureDate)}}</label></p>
<!--        <p>安装日期：<label class="detailContent">{{formatDate(comboVehicleInfo.setupDate)}}</label></p>-->
<!--        <p>备注：<label class="detailContent">{{comboVehicleInfo.remark}}</label></p>-->
      </div>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="dataLoading">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'ComboVehicleInfoDetailModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      dataLoading: false,
      comboVehicleInfo: {
        // 车辆详细信息
        id: null,
        businessState: null,
        commNum: null,
        registrationNum: null,
        registrationColor: null,
        vehicleTypeName: null,
        vehicleBrandName: null,
        frameNum: null,
        engineNum: null,
        chassisNum: null,
        deviceName: null,
        customCompanyName: null,
        customCompanyContact: null,
        customCompanyContactPhone: null,
        vehicleOwnerName: null,
        vehicleOwnerPhone: null,
        vehicleOwnerAddress: null,
        vehicleOwnerIdcardNum: null,
        serviceMatureDate: null,
        setupDate: null,
        remark: null,
        firstContactName: null,
        firstContactPhone: null,
        firstContactAddress: null,
        secondContactName: null,
        secondContactPhone: null,
        secondContactAddress: null,
        thirdContactName: null,
        thirdContactPhone: null,
        thirdContactAddress: null
      }
    }
  },
  methods: {
    ...mapActions([
      'ComboVehicleInfoServ_GetDetail'
    ]),
    formatDate (val) {
      let d = new Date(val)
      return d.Format('yyyy年MM月dd日')
    },
    visibleChange (val) {
      if (val) {
        this.dataLoading = true
        this.comboVehicleInfo.id = null
        this.comboVehicleInfo.businessState = null
        this.comboVehicleInfo.commNum = null
        this.comboVehicleInfo.registrationNum = null
        this.comboVehicleInfo.registrationColor = null
        this.comboVehicleInfo.vehicleTypeName = null
        this.comboVehicleInfo.vehicleBrandName = null
        this.comboVehicleInfo.frameNum = null
        this.comboVehicleInfo.engineNum = null
        this.comboVehicleInfo.chassisNum = null
        this.comboVehicleInfo.deviceName = null
        this.comboVehicleInfo.customCompanyName = null
        this.comboVehicleInfo.customCompanyContact = null
        this.comboVehicleInfo.customCompanyContactPhone = null
        this.comboVehicleInfo.vehicleOwnerName = null
        this.comboVehicleInfo.vehicleOwnerPhone = null
        this.comboVehicleInfo.vehicleOwnerAddress = null
        this.comboVehicleInfo.vehicleOwnerIdcardNum = null
        this.comboVehicleInfo.serviceMatureDate = null
        this.comboVehicleInfo.setupDate = null
        this.comboVehicleInfo.remark = null
        this.comboVehicleInfo.firstContactName = null
        this.comboVehicleInfo.firstContactPhone = null
        this.comboVehicleInfo.firstContactAddress = null
        this.comboVehicleInfo.secondContactName = null
        this.comboVehicleInfo.secondContactPhone = null
        this.comboVehicleInfo.secondContactAddress = null
        this.comboVehicleInfo.thirdContactName = null
        this.comboVehicleInfo.thirdContactPhone = null
        this.comboVehicleInfo.thirdContactAddress = null

        let comboVehicleInfoId = this._initValue
        if (comboVehicleInfoId) {
          store.dispatch('ComboVehicleInfoServ_GetDetail', {
            params: { id: comboVehicleInfoId }
          }).then(() => {
            this.comboVehicleInfo = store.getters.get_ComboVehicleInfo_GetDetailResult
            this.dataLoading = false
          }).catch(err => {
            this.$Message.error(err)
            this.dataLoading = false
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<style scoped>
  .detailContent {
    color: blue;
  }
</style>
